import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import Service from "../../../models/Service";
import Form, { FormInputComponent } from "../../../components/form/Form";
import Modal from "../../../components/Modal";
import ItemSelectModal from "../../../components/ItemSelectModal";
import LoadingBanner from "../../../components/LoadingBanner";
import ErrorBanner from "../../../components/ErrorBanner";
import InfoTooltip from "../../../components/InfoTooltip";
import { Divider, Radio } from "antd";
import PreferenceRatings from "../../talent-preferences/components/PreferenceRatings";
import { TalentAppCard } from '../components/TalentAppCard';


export default class ProjectInterestsStep extends TalentAppStep {

    static path = '/project-interests';
    static LastUpdatedMethod = 'lastUpdatedProjectInterests';

    static HasRequirements = true;
    /**
     * The title shown on the form
     */
    static StepTitle = TB.trans('talent.project_interests.step_title');

    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = 'Specifying your project interests will allow us to match you to ' +
        'appropriate projects and will help us guide you towards completing a better Wripple profile.';
    /**
     * The start page info tile
     */
    static StepInfo = TB.trans('talent.project_interests.step_info');
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Work Preferences';

    /**
     * Show brief details for user
     */
    static ProfileSectionSummary = (user) => {
        if (!this.hasCompleted(user)) return false;
        return `${user.talent_service_groups?.length} Interests Chosen`;
    };


    static hasCompleted(user) {
        if (!TB.isDefined(user.project_interest)) {
            return false;
        }
        if (!user.isOnTalentMarketplace()) {
            return true;
        }
        let items = TB.filter(user.talent_service_groups || [], item => TB.isDefined(item?.id))
        return (items.length > 0 || !laravel.platform_features.talent.services)
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        if (laravel.platform_features.talent.services
            && user.isOnTalentMarketplace() && !user.talent_service_groups?.length) {
            await TB.sysAlert('talent.project_interests_step_service_required')
            return false
        }
        return user.validateProjectInterests()
    };

    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
        this.serviceFormRef = React.createRef();
        this.nestedFormRefs = [React.createRef()];

        this.state = {
            ...this.state,
            isLoading: true,
            allServices: []
        }
    }

    /**
     * @param {User} user
     * @returns {Object}
     */
    static reviewMapping(user) {
        let review = {};
        let workPreferences = {
            [TB.trans('talent.project_interests.review_mapping.type_of_work_label')]: user.project_interest,
            // [TB.trans('talent.project_interests.review_mapping.work_onsite_label')]: user.can_travel_for_work ?
            //     TB.trans('talent.project_interests.review_mapping.work_onsite_answer_yes') :
            //     TB.trans('talent.project_interests.review_mapping.work_onsite_answer_no'),
        }

        if (user.can_travel_for_work) {
            // workPreferences = {
            //     ...workPreferences,
            //     [TB.trans('talent.project_interests.review_mapping.days_per_week_label')]: user.travel_days_per_week,
            //     [TB.trans('talent.project_interests.review_mapping.travel_distance_label')]: user.max_travel_distance + " " + TB.trans('talent.project_interests.review_mapping.travel_distance_unit_of_measurement'),
            //     'Distance Units': user.max_travel_distance_units,
            // }
        }
        review[TB.trans('talent.project_interests.review_mapping.work_preferences_key')] = workPreferences;

        review[`Project Interests`] = user.talent_service_groups?.map((service, index) => <span
            className="block">{service.name}</span>);
        return review;
    }

    componentDidMount() {
        super.componentDidMount();

        this.findAllServices();
    }

    async findAllServices() {
        // TODO Change with updated platform features for teams
        // if (!laravel.platform_features.clients.services) {
        //     return this.promisedState({isLoading: false})
        // }
        let allServices = [];
        if (laravel.talent_service_group_categories) {
            allServices = TB.flatMap(laravel.talent_service_group_categories, cat => {
                return TB.map(cat.groups, group => {
                    return Service.make({
                        ...group,
                        category: TB.omit(cat, ['groups'])
                    })
                })
            })
            console.log('findAllServices', allServices);

        } else {
            allServices = await Service.fetchAllForTalent();
        }
        if (!allServices) {
            return this.handleErrorResponse(
                Service.SearchRequest
            );
        }

        allServices = TB.orderBy([...allServices], 'category.display_index', 'desc');

        this.promisedState({ allServices, isLoading: false })
    }

    async onChange(params) {
        let updates = {};

        TB.map(params, (value, key) => {
            updates = TB.set(updates, key, value);
        })
        super.onChange(updates);
    }

    render() {
        let userServices = TB.map([...(this.props.user?.talent_service_groups || [])], 'id');
        let allServices = this.state.allServices || [];

        let selectedServicesByCategory = TB.groupBy(
            TB.filter(
                allServices, service => userServices.includes(service.id)),
            'category.name'
        )

        let omitServices = false;
        if (userServices.length) {
            omitServices = "?omit[]=" + TB.join(userServices, '&omit[]=')
        }
        return (
            <div className="talent-application px-4 md:px-8 xl:w-10/12 w-full mr-auto ml-0">
                {this.renderTitle()}

                <TalentAppCard className="mb-6">
                    <div className="talent-role-form mb-0 [&_.form-container]:!p-0 [&_.field]:!p-0">
                        <Form
                            ref={this.serviceFormRef}
                            title={null}
                            subtitle={null}
                            showRequired
                            submitButton={false}
                            onChange={async ({ service, ...model }) => {

                                if (typeof service === 'object' && service.id && !userServices.includes(service.id)) {

                                    await this.onChange({
                                        talent_service_groups: [
                                            ...(this.props.user?.talent_service_groups || []),
                                            service
                                        ],
                                        service: ''
                                    })
                                    try {
                                        this.serviceFormRef.current?.forceReset(this.props.user)
                                    } catch (e) {
                                        console.warn('ERROR: e00', e)
                                    }
                                    return;
                                }
                                return this.onChange(model)
                            }}
                            model={this.props.user}
                            fields={[]}
                            isDisabled={this.props.disabled}>

                            <TalentAppCard.Section>

                                <div className="field-section mb-3">

                                    <div className="field px-4 w-full md:w-3/4">
                                        <FormInputComponent
                                            label={TB.trans('talent.project_interests.project_interest_label')}
                                            fieldName={`project_interest`}
                                            placeholder={TB.trans('talent.project_interests.project_interest_placeholder')}
                                            value={this.props.user.project_interest}
                                            validation={{
                                                rules: {
                                                    maxLength: 2000
                                                },
                                                errors: {
                                                    isDefaultRequiredValue: TB.trans('validation.required', {
                                                        'attribute': '',
                                                    }),
                                                    maxLength: TB.trans('validation.max.string', {
                                                        'attribute': 'field',
                                                        'max': 2000
                                                    }),
                                                }
                                            }}
                                            columns={10}
                                            rows={6}
                                            labelClassName="whitespace-normal"
                                            type="textarea"
                                            required={true}
                                            maxLength={2000}
                                        />

                                    </div>
                                </div>

                                <div className="field-section">

                                    <div className="field px-4 w-full md:w-3/4">
                                        <FormInputComponent
                                            label={(
                                                <span className="talent-app-tooltip">
                                                    Are you interested in <b>Team-based</b> projects where you will be part
                                                    of a cross-discipline freelance team curated by {laravel.platform_name}?
                                                    <InfoTooltip placement="right">
                                                        <p className="mb-0 text-white text-left">
                                                            For team-based projects, you'll typically work collaboratively with
                                                            others to complete a defined set of deliverables at a fixed price.
                                                            {laravel.platform_name} curates freelance teams tailored to your
                                                            role and project interests (see below). You can also assemble your
                                                            own custom teams using the tools available on
                                                            your {laravel.platform_name} dashboard.
                                                        </p>
                                                    </InfoTooltip>
                                                </span>
                                            )}
                                            fieldName={`has_auto_team_matching_interest`}
                                            value={this.props.user.has_auto_team_matching_interest}
                                            validationErrors={{
                                                isDefaultRequiredValue: 'Your response is required'
                                            }}
                                            labelClassName="whitespace-normal"
                                            type="antd-input"
                                            required={true}
                                            columns={10}
                                        >
                                            <Radio.Group
                                                defaultValue={this.props.user.has_auto_team_matching_interest}>
                                                <Radio value={true}>Yes</Radio>
                                                <Radio value={false}>No</Radio>
                                            </Radio.Group>

                                        </FormInputComponent>
                                    </div>

                                    <div className="field px-4 w-full md:w-3/4">
                                        <FormInputComponent
                                            label={(
                                                <span className="talent-app-tooltip">
                                                    Are you interested in <b>Individual</b> staffing assignments that require
                                                    your expertise?
                                                    <InfoTooltip placement="right">
                                                        <p className="mb-0 text-white text-left">
                                                            Individual staffing assignments are typically time-and-material
                                                            (hourly) roles where you function as an integrated member of our
                                                            client's team. Based on your expertise and skill set, you will take
                                                            on a specialized position to support the team's objectives. These
                                                            assignments may span several weeks, months, or even years, depending
                                                            on the project's scope and requirements.
                                                        </p>
                                                    </InfoTooltip>
                                                </span>
                                            )}
                                            fieldName={`offers_byo_work`}
                                            value={this.props.user.offers_byo_work}
                                            validationErrors={{
                                                isDefaultRequiredValue: 'Your response is required'
                                            }}
                                            labelClassName="whitespace-normal"
                                            type="antd-input"
                                            required={true}
                                            columns={10}
                                        >
                                            <Radio.Group
                                                defaultValue={this.props.user.offers_byo_work}>
                                                <Radio value={true}>Yes</Radio>
                                                <Radio value={false}>No</Radio>
                                            </Radio.Group>

                                        </FormInputComponent>
                                    </div>
                                </div>
                            </TalentAppCard.Section>

                            {/* <Divider /> */}


                            {TB.isObject(this.state.error) &&
                                <ErrorBanner {...this.state.error} onRetry={() => this.findAllServices()} />}


                            {this.state.isLoading && <LoadingBanner message="Loading project interests" />}

                            {!this.state.isLoading && !TB.isObject(this.state.error) && (
                                <TalentAppCard.Section>

                                    <div className="form-title-section">
                                        <div className="step-title-content px-0">
                                            <div>
                                                <h3 className="form-title">
                                                    Project Types on Wripple
                                                </h3>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="field-section">

                                        <div className="field px-4">
                                            <FormInputComponent
                                                type="search"
                                                fieldName="service"
                                                searchType="talent_service_groups"
                                                placeholder={TB.trans('talent.talent_service_form.service_placeholder')}
                                                valueLabelDisplay="name"
                                                disabled={this.props.disabled}
                                                label={TB.trans('talent.talent_service_form.service_label')}
                                                required={false}
                                                searchRequestEndpoint={`/api/talent-service-groups${omitServices || ''}`}
                                                validations={{
                                                    serviceNotSelected: ({ service }, value) => {
                                                        if (!TB.isDefined(value?.id)) {
                                                            return TB.trans('talent.talent_service_form.service_not_selected_validation_msg')
                                                        }

                                                        return TB.isDefined(value?.id) ? true : TB.trans('validation.required', {
                                                            'attribute': "service",
                                                        })
                                                    },
                                                }}
                                                appendAfter={(
                                                    <p className="btn-form-modal" onClick={() => {
                                                        this.modalRef.current.showModal({ title: TB.trans('talent.talent_service_form.modal_title') });
                                                    }}>
                                                        {TB.trans('talent.talent_service_form.modal_link')}
                                                    </p>
                                                )} />
                                        </div>
                                    </div>
                                    {TB.keys(selectedServicesByCategory).length > 0 && (
                                        <div className="row no-gutters">
                                            <div className="md:w-8/12">
                                                <div className="removable-list px-0">

                                                    <h3 className="text-sm">Currently Selected Interests</h3>
                                                    {TB.keys(selectedServicesByCategory).map((category) => {
                                                        return (
                                                            <div key={category} className="removable-list-section">
                                                                <h4>{category}</h4>
                                                                {selectedServicesByCategory[category].map(service => (
                                                                    <div key={service.id}
                                                                        className="removable-list-item">
                                                                        <p>
                                                                            <span>
                                                                                {service.name}
                                                                            </span>
                                                                            <span className="clickable"
                                                                                onClick={() => this.toggleService(service)}>
                                                                                <i className="fa fa-times" />
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </TalentAppCard.Section>

                            )}

                        </Form>
                    </div>
                </TalentAppCard>


                {!this.state.isLoading
                    && !TB.isObject(this.state.error)
                    && this.state.allServices?.length > 0 && (
                        <Modal ref={this.modalRef}>
                            <ItemSelectModal
                                fieldName="talent_service_groups"
                                selectText="Select"
                                multiSelect={true}
                                selectedIds={TB.map(TB.tryArray(this.props.user.talent_service_groups), 'id')}
                                isDisabled={false}
                                categoryHeader="Project Category"
                                itemHeader="Project Type"
                                items={this.state.allServices}
                                hideModal={() => this.modalRef.current.hideModal()}
                                toggleItem={this.toggleService.bind(this)}
                            />
                        </Modal>
                    )}

                <TalentAppCard>
                    <TalentAppCard.Section>
                        <div className="px-8py-6 talent-preferences-panel shadow-none mt-0">
                            <div className="form-title-section mb-0">
                                <div className="px-0 mb-0 step-title-content" style={{ minHeight: 'unset!important' }}>
                                    <div>
                                        <h3 className="form-title text-base mb-0">
                                            Interest in Assignments
                                        </h3>

                                    </div>
                                </div>
                            </div>

                            <PreferenceRatings
                                disabled={this.props.disabled}
                                preferences={this.props.user.talentPreferences()}
                                onChange={this.onChange.bind(this)}
                            />
                        </div>
                    </TalentAppCard.Section>
                </TalentAppCard>
            </div>
        );
    }


    toggleService(service) {
        let talent_service_groups = TB.xorBy([...(this.props.user.talent_service_groups || [])], [{ ...service }], 'id');

        this.onChange({ talent_service_groups })
    }

    /**
     * Are requirements completed?
     *
     * @returns boolean
     */
    isRequirementComplete() {
        return !this.props.authUser?.isOnTalentMarketplace() ||
            TB.filter([...(this.props.authUser.talent_service_groups || [])], ser => !!ser?.id)?.length >= 1;
    }
    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return this.props.authUser?.isOnTalentMarketplace() ? 'At least 1 Project Type is required.' : 'Project Types are optional and not required.';
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};